var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStaff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 26.3l-7.1-4v-1.1c1-1.4 1.8-3.3 1.9-5.6h.3c.5 0 .8-.4.8-.8 0-.6-.3-1.2-.6-1.8V9.9c0-1.3-.8-2.4-1.9-2.9l-3.6-1.6c-1.1-.5-2.4-.5-3.5 0L14.7 7c-1.2.5-1.9 1.6-1.9 2.9v3.2c-.5.5-.6 1.1-.6 1.8 0 .5.4.8.8.8h.1c.2 2.1.8 4 1.9 5.4v1.3l-7.1 4c-.6.2-.9.8-.9 1.5v6.8c0 .5.4.8.8.8h24.3c.5 0 .8-.4.8-.8v-6.8c.1-.6-.3-1.3-.9-1.6zM15.4 8.5L19 7c.6-.3 1.4-.3 2.1 0l3.6 1.6c.5.3.9.8.9 1.4v1.8c-1.4-.7-3.4-1.2-5.6-1.2s-4.1.5-5.6 1.2V9.9c.1-.6.4-1.1 1-1.4zm4.7 3.7c2.7 0 4.9.8 5.8 1.8H14.3c.8-.9 3-1.8 5.8-1.8zm-5.3 3.4h10.3c-.3 3.1-1.7 6.3-5.2 6.3-2.7.1-4.7-2.6-5.1-6.3zM13.7 25l2.6-1.4c.3-.1.5-.5.5-.7v-.2c1 .6 2.1 1 3.2 1 1.2 0 2.3-.3 3.2-.9v.1c0 .3.2.6.5.7l2.6 1.4v3.6H13.7V25zM12 33.9H8.6V28c0-.1.1-.1.1-.1l3.2-1.8.1 7.8zm1.7 0v-3.6h12.6v3.6H13.7zm17.6 0H28V26l3.2 1.8.1.1v6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.797a4136.svg";
export { ForwardRef as ReactComponent };